<template>
    <!-- Оновной контейнер для поискового хэдера -->
    <div class="main-search-header-container">
        <!-- Строка поиска -->
        <div class="search-container">
            <img src="../assets/icons/magnifying-glass (1).png" alt="Иконка поиска" class="search-icon" />
            <input
                type="text"
                id="search"
                class="search-input"
                placeholder="Поиск..."
                ref="searchInput"
                @input="onInput"
            >
        </div>
    </div>

    <!-- Фото челика -->
    <img src="../assets/images-templates/дорисовано-Photoroom.png" alt="" class="tbm-human">

    <!-- Текст (слоган) -->
    <div class="tbm-slogan">
        <div class="f-part">Стиль</div>
        <div class="s-part">имеет значение!</div>
    </div>
</template>

<script>
export default{
    mounted() {
        document.addEventListener("click", this.handleGlobalClick);
    },
    beforeUnmount() {
        document.removeEventListener("click", this.handleGlobalClick);
    },

    emits: ['search-change'], // объявляем эмит события

    methods: {
        handleGlobalClick(event) {
            if (
                this.$refs.searchInput &&
                !this.$refs.searchInput.contains(event.target)
            ) {
                this.$refs.searchInput.blur();
            }
            },

            onInput(event) {
            this.$emit('search-change', event.target.value.trim());
        },
    }
    
}

</script>

<style scoped>
.main-search-header-container {
    margin-bottom: 6vw;
    position: relative;
    height: 50vw;
}

.search-container {
    position: relative;
}

.search-icon {
    position: absolute;
    top: 0.5vw;
    left: 1vw;
    width: 10vw;
    height: auto;
}

.search-input {
    width: 100%;
    height: 11vw;
    border-radius: 20px;
    border: 1px solid white;
    padding-left: 12vw;
    background-color: rgba(255, 255, 255, 0);
    color: white;
    font-size: 18px;
}

.search-input::placeholder {
    color: rgba(255, 255, 255, 0.8);
    font-style: italic;
    font-weight: 800;
    font-size: 18px;
}

.tbm-human {
    position: absolute;
    top: 22vw;
    right: 0;
    width: 73%;
    height: auto;
    z-index: 2; /* Чтобы не перекрывать элементы */
    pointer-events: none;
}

.tbm-slogan {
    color: white;
    position: absolute;
    top: 66vw;
    left: 4vw;
    z-index: 4;
    font-family: 'CentureGothic', sans-serif;
    font-weight: bold;
    font-style: italic;
    letter-spacing: 8%; 
}

.f-part {
    font-size: 40px;
}

.s-part {
    font-size: 32px;
    margin-top: -3vw;
}
</style>